import MsBHUMultiSiteListContainer from './container'
export default MsBHUMultiSiteListContainer
